import React, { FC } from 'react';
import { Link } from '@material-ui/core';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';
import { Alert } from '@dev/ee-components';
import InProgressAlertInterface from './InProgressAlertInterface';
import { DeliveryPausedReason } from '@dev/ee-api/ee-api-models';
import { isIntercomEnabled } from '@api/services/Security';
import { useSecurity } from '@api/services/hooks/useSecurity';
const AlertWrapper = styled.div`
    margin-top: 32px;
`;

const InProgressAlert: FC<InProgressAlertInterface> = (props: InProgressAlertInterface): JSX.Element => {
    const { show } = useIntercom() || {};
    const { t } = useTranslation();
    const { isReseller } = useSecurity();
    const { pausedReason } = props;
    const launchIntercom = (): void => {
        isIntercomEnabled() && show();
    };
    const isAccountInActive = pausedReason === DeliveryPausedReason.AccountInActive;
    const severity = isAccountInActive ? 'error' : 'warning';
    const alertBody = isAccountInActive ? (
        <Trans
            i18nKey="accountinactive"
            components={{
                url: !isReseller ? <Link onClick={launchIntercom} /> : <></>,
            }}
        />
    ) : (
        t('accountmaintenanceinprogress')
    );
    return (
        <AlertWrapper>
            <Alert severity={severity} body={<div>{alertBody}</div>} />
        </AlertWrapper>
    );
};

export default InProgressAlert;
